"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.swapBufferLayout = void 0;
/**
 * @internal
 */
function swapBufferLayout(graphicsComponent, entityBufferLayout) {
    if (graphicsComponent.transform.bufferLayoutProvider && entityBufferLayout != null) {
        graphicsComponent.transform.bufferLayoutProvider.setBufferLayout(entityBufferLayout);
    }
}
exports.swapBufferLayout = swapBufferLayout;
//# sourceMappingURL=swap-buffer-layout.js.map